import { SelectItem } from 'primeng/api';
import { Injectable } from "@angular/core";

@Injectable()
export class AppConstants {
  italyCountryId = 39;
  modelsLoaded = false;
  // sign-up form
  it = {
    firstDayOfWeek: 0,
    dayNames: [
      'domenica',
      'lunedì',
      'martedì',
      'mercoledì',
      'giovedì',
      'venerdì',
      'sabato'
    ],
    dayNamesShort: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
    dayNamesMin: ['Do', 'Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa'],
    monthNames: [
      'gennaio',
      'febbraio',
      'marzo',
      'aprile',
      'maggio',
      'giugno',
      'luglio',
      'agosto',
      'settembre',
      'ottobre',
      'novembre',
      'dicembre'
    ],
    monthNamesShort: [
      'gen',
      'feb',
      'mar',
      'apr',
      'mag',
      'giu',
      'lug',
      'ago',
      'set',
      'ott',
      'nov',
      'dic'
    ],
    today: 'Oggi',
    clear: 'Chiaro'
  };

  en = {
    firstDayOfWeek: 0,
    dayNames: [
      'sunday',
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday'
    ],
    dayNamesShort: ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    monthNames: [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december'
    ],
    monthNamesShort: [
      'jan',
      'feb',
      'mar',
      'apr',
      'may',
      'jun',
      'jul',
      'aud',
      'sep',
      'oct',
      'nov',
      'dec'
    ],
    today: 'Today',
    clear: 'Clear'
  };

  appleTablets: SelectItem[] = [
    { label: 'iPad 2', value: 'iPad 2' },
    { label: 'iPad 3', value: 'iPad 3' },
    { label: 'iPad 4', value: 'iPad 4' },
    { label: 'iPad Mini', value: 'iPad Mini' },
    { label: 'iPad Mini 2', value: 'iPad Mini 2' },
    { label: 'iPad Mini 3', value: 'iPad Mini 3' },
    { label: 'iPad Mini 4', value: 'iPad Mini 4' },
    { label: 'iPad Air', value: 'iPad Air' },
    { label: 'iPad Air 2', value: 'iPad Air 2' },
    { label: 'iPad Pro', value: 'iPad Pro' },
    { label: 'iPad 5', value: 'iPad 5' },
    { label: 'iPad 6', value: 'iPad 6' },
    { label: 'iPad 7', value: 'iPad 7' },
    { label: 'iPad Mini 5', value: 'iPad Mini 5' },
    { label: 'iPad Air 3', value: 'iPad Air 3' },
    { label: 'Altro', value: 'Altro' }
  ];
  appleSmartphones: SelectItem[] = [

    { label: 'iPhone 5', value: 'iPhone 5' },
    { label: 'iPhone 5C', value: 'iPhone 5C' },
    { label: 'iPhone 5S', value: 'iPhone 5S' },
    { label: 'iPhone SE', value: 'iPhone SE' },
    { label: 'iPhone 6', value: 'iPhone 6' },
    { label: 'iPhone 6 Plus', value: 'iPhone 6 Plus' },
    { label: 'iPhone 6S', value: 'iPhone 6S' },
    { label: 'iPhone 6S Plus', value: 'iPhone 6S Plus' },
    { label: 'iPhone 7', value: 'iPhone 7' },
    { label: 'iPhone 7 Plus', value: 'iPhone 7 Plus' },
    { label: 'iPhone 8', value: 'iPhone 8' },
    { label: 'iPhone 8 Plus', value: 'iPhone 8 Plus' },
    { label: 'iPhone X', value: 'iPhone X' },
    { label: 'iPhone XS', value: 'iPhone X' },
    { label: 'iPhone XS Max', value: 'iPhone X' },
    { label: 'iPhone XR', value: 'iPhone X' },
    { label: 'iPhone 11', value: 'iPhone 11' },
    { label: 'iPhone 11 Pro', value: 'iPhone 11 Pro' },
    { label: 'iPhone 11 Pro Max', value: 'iPhone 11 Pro Max' },
    { label: 'Altro', value: 'Altro' }

  ];
  // Respondent Demographic
  // occupationOptions: SelectItem[] = [
  //   { label: 'Clerk', value: '1' },
  //   { label: 'Artisan', value: '2' },
  //   { label: 'Teacher/Professor', value: '3' },
  //   { label: 'Business Manager', value: '4' },
  //   { label: 'Armed forces', value: '5' },
  //   { label: 'Worker', value: '6' },
  //   { label: 'Professional', value: '7' },
  //   { label: 'Vendor / Representative', value: '8' },
  //   { label: 'Employee in the Service Sector', value: '9' },
  //   { label: 'Technical', value: '10' },
  //   { label: 'Other', value: '11' }
  // ];
  occupationOptions: SelectItem[] = [
    { label: 'Impiegato/Amministrativo', value: 1 },
    { label: 'Artigiano', value: 2 },
    { label: 'Insegnante/Professore', value: 3 },
    { label: 'Manager d\'azienda', value: 4 },
    { label: 'Forze armate', value: 5 },
    { label: 'Operaio', value: 6 },
    { label: 'Professionista', value: 7 },
    { label: 'Venditore/rappresentante', value: 8 },
    { label: 'Impiegato/a nel settore dei servizi', value: 9 },
    { label: 'Tecnico', value: 10 },
    { label: 'Altro', value: 11 }
  ];

  phoneTypeOptions: SelectItem[] = [
    { label: 'Mobile', value: 'Mobile' },
    { label: 'Casa', value: 'Home' },
    { label: 'Ufficio', value: 'Office' }
  ];

  stateOptions: SelectItem[] = [
    { label: 'AG', value: 'AG' },
    { label: 'AL', value: 'AL' },
    { label: 'AN', value: 'AN' },
    { label: 'AO', value: 'AO' },
    { label: 'AP', value: 'AP' },
    { label: 'AQ', value: 'AQ' },
    { label: 'AR', value: 'AR' },
    { label: 'AT', value: 'AT' },
    { label: 'AV', value: 'AV' },
    { label: 'BA', value: 'BA' },
    { label: 'BG', value: 'BG' },
    { label: 'BI', value: 'BI' },
    { label: 'BL', value: 'BL' },
    { label: 'BN', value: 'BN' },
    { label: 'BO', value: 'BO' },
    { label: 'BR', value: 'BR' },
    { label: 'BS', value: 'BS' },
    { label: 'BT', value: 'BT' },
    { label: 'BZ', value: 'BZ' },
    { label: 'CA', value: 'CA' },
    { label: 'CB', value: 'CB' },
    { label: 'CE', value: 'CE' },
    { label: 'CH', value: 'CH' },
    { label: 'CI', value: 'CI' },
    { label: 'CL', value: 'CL' },
    { label: 'CN', value: 'CN' },
    { label: 'CO', value: 'CO' },
    { label: 'CR', value: 'CR' },
    { label: 'CS', value: 'CS' },
    { label: 'CT', value: 'CT' },
    { label: 'CZ', value: 'CZ' },
    { label: 'EN', value: 'EN' },
    { label: 'FC', value: 'FC' },
    { label: 'FE', value: 'FE' },
    { label: 'FG', value: 'FG' },
    { label: 'FI', value: 'FI' },
    { label: 'FM', value: 'FM' },
    { label: 'FR', value: 'FR' },
    { label: 'GE', value: 'GE' },
    { label: 'GO', value: 'GO' },
    { label: 'GR', value: 'GR' },
    { label: 'IM', value: 'IM' },
    { label: 'IS', value: 'IS' },
    { label: 'KR', value: 'KR' },
    { label: 'LC', value: 'LC' },
    { label: 'LE', value: 'LE' },
    { label: 'LI', value: 'LI' },
    { label: 'LO', value: 'LO' },
    { label: 'LT', value: 'LT' },
    { label: 'LU', value: 'LU' },
    { label: 'MB', value: 'MB' },
    { label: 'MC', value: 'MC' },
    { label: 'ME', value: 'ME' },
    { label: 'MI', value: 'MI' },
    { label: 'MN', value: 'MN' },
    { label: 'MO', value: 'MO' },
    { label: 'MS', value: 'MS' },
    { label: 'MT', value: 'MT' },
    { label: 'NA', value: 'NA' },
    { label: 'NO', value: 'NO' },
    { label: 'NU', value: 'NU' },
    { label: 'OG', value: 'OG' },
    { label: 'OR', value: 'OR' },
    { label: 'OT', value: 'OT' },
    { label: 'PA', value: 'PA' },
    { label: 'PC', value: 'PC' },
    { label: 'PD', value: 'PD' },
    { label: 'PE', value: 'PE' },
    { label: 'PG', value: 'PG' },
    { label: 'PI', value: 'PI' },
    { label: 'PN', value: 'PN' },
    { label: 'PO', value: 'PO' },
    { label: 'PR', value: 'PR' },
    { label: 'PT', value: 'PT' },
    { label: 'PU', value: 'PU' },
    { label: 'PV', value: 'PV' },
    { label: 'PZ', value: 'PZ' },
    { label: 'RA', value: 'RA' },
    { label: 'RC', value: 'RC' },
    { label: 'RE', value: 'RE' },
    { label: 'RG', value: 'RG' },
    { label: 'RI', value: 'RI' },
    { label: 'RM', value: 'RM' },
    { label: 'RN', value: 'RN' },
    { label: 'RO', value: 'RO' },
    { label: 'SA', value: 'SA' },
    { label: 'SI', value: 'SI' },
    { label: 'SO', value: 'SO' },
    { label: 'SP', value: 'SP' },
    { label: 'SR', value: 'SR' },
    { label: 'SS', value: 'SS' },
    { label: 'SV', value: 'SV' },
    { label: 'TA', value: 'TA' },
    { label: 'TE', value: 'TE' },
    { label: 'TN', value: 'TN' },
    { label: 'TO', value: 'TO' },
    { label: 'TP', value: 'TP' },
    { label: 'TR', value: 'TR' },
    { label: 'TS', value: 'TS' },
    { label: 'TV', value: 'TV' },
    { label: 'UD', value: 'UD' },
    { label: 'VA', value: 'VA' },
    { label: 'VB', value: 'VB' },
    { label: 'VC', value: 'VC' },
    { label: 'VE', value: 'VE' },
    { label: 'VI', value: 'VI' },
    { label: 'VR', value: 'VR' },
    { label: 'VS', value: 'VS' },
    { label: 'VT', value: 'VT' },
    { label: 'VV', value: 'VV' }
  ];

  incomeOptions: SelectItem[] = [
    { label: 'Fino a 1.150 euro', value: 1 },
    { label: 'Da 1151 a 1.400 euro', value: 2 },
    { label: 'Da 1.401 a 1.650 euro', value: 3 },
    { label: 'Da 1.651 a 1.900 euro', value: 4 },
    { label: 'Da 1.901 a 2.150 euro', value: 5 },
    { label: 'Da 2.151 a 2.400 euro', value: 6 },
    { label: 'Da 2.401 a 2.650 euro', value: 7 },
    { label: 'Da 2.651 a 3.250 euro', value: 8 },
    { label: 'Da 3.251 a 3.850 euro', value: 9 },
    { label: 'Da 3.851 a 5.000 euro', value: 10 },
    { label: 'Oltre 5.000 euro', value: 11 }
  ];

  countries: SelectItem[] = [
    { label: 'Italia', value: 'IT', title: '39' },
    { label: 'Australia', value: 'AU', title: '61' },
    { label: 'Brasile', value: 'BR', title: '55' },
    { label: 'Cina', value: 'CN', title: '86' },
    { label: 'Francia', value: 'FR', title: '33' },
    { label: 'Germania', value: 'DE', title: '49' },
    { label: 'Nuova Zelanda', value: 'NZ', title: '64' },
    { label: 'Regno Unito', value: 'GB', title: '44' },
    { label: 'Spagna', value: 'ES', title: '34' },
    { label: 'Svizzera', value: 'CH', title: '41' },
    { label: 'Stati Uniti d\'America', value: 'US', title: '1' },
    { label: 'Altro', value: 'Other', title: '' }
  ];
  nationalities: SelectItem[] = [
    { label: 'Italiana', value: 'Italian' },
    { label: 'Non Italiana ma EU', value: 'Not italian but European' },
    {
      label: 'Extra EU',
      value: 'Extra European'
    }
  ];
  enESOtherOptions = [
    { label: 'Other (Please specify)', value: 99 },
    { label: 'None of the options listed above', value: 0 }
  ];
  itESOtherOptions = [
    { label: 'Altro (Per favore specifica)', value: 99 },
    { label: 'Nessuna delle opzioni sopra elencate', value: 0 }
  ];
  enExitSurveyReasons = [
    {
      label: 'The application has been identified as Adware or Spyware',
      value: 12
    },
    {
      label:
        'The application interferes with other programs installed on my computer',
      value: 7
    },
    { label: 'I\'m worried about viruses and / or spyware', value: 13 },
    { label: 'I\'m currently using a different computer', value: 11 },
    { label: 'The application slows down my Internet browsing', value: 3 },
    {
      label:
        'The application interferes with other programs installed on my computer',
      value: 2
    },
    { label: 'Non ricevo quasi mai sondaggi da Nielsen', value: 14 },
    { label: 'The application slows down my computer', value: 1 },
    { label: 'I\'m worried about my privacy', value: 8 },
    { label: 'Surveys do not allow you to contact Nielsen directly', value: 5 },
    { label: 'I\'m not satisfied with the rewards program', value: 4 },
    { label: 'The application blocks or crashes my computer', value: 6 },
    { label: 'My employer asked me to remove the application', value: 10 },
    { label: 'I changed employer', value: 9 }
  ];
  itExitSurveyReasons = [
    {
      label: 'L\'applicazione è stata identificata come Adware o Spyware',
      value: 12
    },
    {
      label:
        'Un componente del nucleo familiare mi ha chiesto di disinstallare l\'applicazione',
      value: 7
    },
    { label: 'Sono preoccupato per virus e/o spyware', value: 13 },
    { label: 'Al momento sto utilizzando un computer diverso', value: 11 },
    { label: 'L\'applicazione rallenta la mia navigazione Internet ', value: 3 },
    {
      label:
        'L\'applicazione interferisce con altri programmi installati sul mio computer',
      value: 2
    },
    { label: 'Non ricevo quasi mai sondaggi da Nielsen', value: 999 },
    { label: 'L\'applicazione rallenta il mio computer', value: 1 },
    { label: 'Sono preoccupato per la mia privacy', value: 8 },
    {
      label: 'I sondaggi non permettono di contattare direttamente Nielsen',
      value: 5
    },
    { label: 'Non sono soddisfatto del programma premi', value: 4 },
    {
      label: 'L\'applicazione blocca o manda in crash il mio computer',
      value: 6
    },
    {
      label:
        'Il mio datore di lavoro mi ha chiesto di rimuovere l\'applicazione',
      value: 10
    },
    { label: 'Ho cambiato datore di lavoro', value: 9 }
  ];
  // contact us form
  emailCategories: SelectItem[] = [
    { label: 'Computer', value: 'Computer' },
    { label: 'Dispositivo mobile', value: 'Dispositivo mobile' },
    { label: 'Generica', value: 'Generica' }
  ];
  emailSubCategories: {} = {
    Computer: [
      {
        label: 'Disinstallazione da computer',
        value: 'Disinstallazione da computer'
      },
      { label: 'Premi per computer', value: 'Premi per computer' },
      {
        label: 'Installazione dell\'App su computer',
        value: 'Installazione dell\'App su computer'
      },
      { label: 'Prestazioni del computer', value: 'Prestazioni del computer' },
      {
        label: 'Informazioni sull\'App per computer',
        value: 'Informazioni sull\'App per computer'
      },
      { label: 'Altri sondaggi', value: 'Altri sondaggi' },
      { label: 'Altro (computer)', value: 'Altro (computer)' }
    ],
    'Dispositivo mobile': [
      {
        label: 'Disinstallazione da dispositivo mobile',
        value: 'Disinstallazione da dispositivo mobile'
      },
      {
        label: 'Premi per dispositivi mobili',
        value: 'Premi per dispositivi mobili'
      },
      {
        label: 'Installazione dell\'App su dispositivi mobili',
        value: 'Installazione dell\'App su dispositivi mobili'
      },
      {
        label: 'Prestazioni dei dispositivi mobili',
        value: 'Prestazioni dei dispositivi mobili'
      },
      {
        label: 'Informazioni sull\'App per dispositivi mobili',
        value: 'Informazioni sull\'App per dispositivi mobili'
      },
      {
        label: 'Altro (dispositivi mobili)',
        value: 'Altro (dispositivi mobili)'
      }
    ],
    Generica: [
      {
        label: 'Annullamento iscrizione o disinstallazione',
        value: 'Annullamento iscrizione o disinstallazione'
      },
      { label: 'Premi', value: 'Premi' },
      { label: 'La tua partecipazione', value: 'La tua partecipazione' },
      { label: 'Privacy e riservatezza', value: 'Privacy e riservatezza' },
      { label: 'Il tuo profilo', value: 'Il tuo profilo' },
      { label: 'Altri sondaggi', value: 'Altri sondaggi' },
      { label: 'Altro', value: 'Altro' }
    ]
  };

  OS_SUPPORTED: String[] = [
    // Windows
    'windows-7',
    'windows-8-1',
    'windows-8',
    'windows-10',
    // MAC
    'mac-os-x-15',
    'mac-os-x-14',
    'mac-os-x-13',
    // 'mac-os-x-12',
    // 'mac-os-x-11',
    // 'mac-os-x-10',
    // 'mac-os-x-9'
  ];
}
